module.exports = __webpack_public_path__ + "img/s_3.40fce7d8.jpg";